import * as React from 'react'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Dropdown from 'react-bootstrap/Dropdown'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

export const NormalUserFilters = (props) => {
  const { setFilterData, filterData } = props

  const clearDates = () => {
    setFilterData((pre) => ({ ...pre, startDate: null, endDate: null }))
  }

  return (
    <div
      className='card-header border-0 user-manager-filters'
      style={{ overflow: 'visible', position: 'relative', zIndex: 30, maxWidth: '100%' }}
    >
      <div className='row align-items-center text-left'>
        <div className='col-md-3'>
          <InputGroup className='mb-2' style={{ borderRadius: '10px' }}>
            <Form.Control
              placeholder='Search by user name or ID'
              value={filterData?.searchText || ''}
              onChange={(e) => setFilterData((pre) => ({ ...pre, searchText: e.target.value }))}
              onKeyDown={(e) => e.key === 'Enter' && props?.handleFilterClick()}
            />
          </InputGroup>
        </div>
        <div className='col-md-3'>
          <InputGroup className='mb-2' style={{ borderRadius: '10px' }}>
            <Form.Control
              placeholder='Search by contact number'
              value={filterData?.contactNumber || ''}
              onChange={(e) => setFilterData((pre) => ({ ...pre, contactNumber: e.target.value }))}
              onKeyDown={(e) => e.key === 'Enter' && props?.handleFilterClick()}
            />
          </InputGroup>
        </div>
        <div className='col-md-2 mb-2 '>
          <Dropdown>
            <Dropdown.Toggle
              variant='success'
              style={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #cad1d7',
                boxShadow: 'none',
                transform: 'none'
              }}
              id='dropdown-basic'
            >
              {filterData?.accountStatus || 'Select Status'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => setFilterData((pre) => ({ ...pre, accountStatus: 'Select Status' }))}
              >
                Select Status
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterData((pre) => ({ ...pre, accountStatus: 'Active' }))}>
                Active
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterData((pre) => ({ ...pre, accountStatus: 'In Active' }))}>
                In Active
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* --- ADDED GRADE STATUS FILTER --- */}
        <div className='col-md-2'>
          <Dropdown>
            <Dropdown.Toggle
              variant='success'
              className='w-100'
              style={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #cad1d7',
                boxShadow: 'none',
                transform: 'none'
              }}
              id='dropdown-grade-status'
            >
              {/* This logic determines the display text */}
              {filterData?.isGrade === true
                ? 'Graded Users'
                : filterData?.isGrade === false
                  ? 'Ungraded Users'
                  : 'All Users (Grade)'}
            </Dropdown.Toggle>
            <Dropdown.Menu className='w-100'>
              <Dropdown.Item
                onClick={() =>
                  setFilterData((pre) => ({ ...pre, isGrade: null }))
                }
              >
                All Users (Grade)
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() =>
                  setFilterData((pre) => ({ ...pre, isGrade: true }))
                }
              >
                Graded Users
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() =>
                  setFilterData((pre) => ({ ...pre, isGrade: false }))
                }
              >
                Ungraded Users
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>


        <div className='col-md-6 mb-3' style={{ marginLeft: '40px' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box display='flex' flexWrap='wrap' alignItems='center' gap={1}>
              <DemoContainer components={['DatePicker', 'DatePicker']} sx={{ pt: 0, overflow: 'visible' }}>
                <DatePicker
                  disableFuture
                  className='custom-date'
                  label='From Date'
                  value={filterData?.startDate || null}
                  onChange={newValue => setFilterData((pre) => ({ ...pre, startDate: newValue }))}
                  maxDate={filterData?.endDate || undefined}
                  slotProps={{ textField: { size: 'small' } }}
                />
                <DatePicker
                  disableFuture
                  label='To Date'
                  minDate={filterData?.startDate || undefined}
                  value={filterData?.endDate || null}
                  onChange={newValue => setFilterData((pre) => ({ ...pre, endDate: newValue }))}
                  slotProps={{ textField: { size: 'small' } }}
                />
              </DemoContainer>
              {(filterData?.startDate || filterData?.endDate) && (
                <Button
                  size='small'
                  variant='text'
                  onClick={clearDates}
                  sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                >
                  Clear dates
                </Button>
              )}
            </Box>
          </LocalizationProvider>
        </div>
        {/* <div className='col-md-1 mb-2 '>
          <Dropdown>
            <Dropdown.Toggle
              variant='success'
              style={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #cad1d7',
                boxShadow: 'none',
                transform: 'none'
              }}
              id='dropdown-basic'
            >
              {filterData?.subscription || 'Select Subscription'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => setFilterData((pre) => ({ ...pre, subscription: 'Select Subscription' }))}
              >
                Select Subscription
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => setFilterData((pre) => ({ ...pre, subscription: 'Subscription Name' }))}
              >
                Subscription Name
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div> */}
        <div className='col-md-3 mb-2'>
          <Button
            variant='contained'
            className='custom-filter-btn'
            onClick={() => props?.handleFilterClick()}
          >
            Filter
          </Button>
          <Button
            variant='contained'
            className='ml-2 custom-filter-btn'
            onClick={() => props?.handleResetFilter()}
          >
            Reset
          </Button>
        </div>
      </div>
    </div >
  )
}
